import { MessageService } from '@progress/kendo-angular-l10n';
import { kendoSpanishMessages } from './messages/kendo-messages-es';

export class MyMessageService extends MessageService {
  private localeId = 'es';
  private messagesMap: { [key: string]: { [key: string]: string } } = {
    es: kendoSpanishMessages,
  };

  public set language(lang: string) {
    if (this.messagesMap[lang]) {
      this.localeId = lang;
      this.notify(false); // rtl = false
    } else {
      this.localeId = ''; // idioma no disponible
      this.notify(false); // Kendo UI usará su default
    }
  }

  public get language(): string {
    return this.localeId || 'default';
  }

  private get messages(): { [key: string]: string } | undefined {
    return this.messagesMap[this.localeId];
  }

  public override get(key: string): string | undefined {
    // Si hay mensaje en tu map, lo devuelve; si no, undefined para fallback de Kendo
    return this.messages?.[key];
  }
}
